export const isAuthenticated = (store) => {
    let apiKey = !!selectApiKey(store);
    let authToken = !!localStorage.getItem('access_token');
    let token = store.router.query.token;
    return !!(apiKey || authToken || token);
};

export const selectApiKey = (store) => {
    return store.auth.api_key;
};